import {
    I2cCheckbox, I2cCheckboxGroup, I2cListItem
} from "@webcomponents/i2cwebcomponents/dist/react";
import React, { useEffect, useRef } from "react";
import "../PrepaidComponents/Prepaid.scss";
import { useForm, Controller } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import ErrorMessage from "../../Components/SharedComponent/ErrorMessage/ErrorMessage";
const CardProfileRegistration = ({
    setAddFormData,
    addFormData,
    setFormValidStates,
    formDataJson,
    isFetching,
}) => {
    const checkboxRef = useRef(null);
    const cardProfileReg = ["Last 4 digits of SSN [for US only]", "SSN [for US only]", "ZIP code",
        "Last 4 digits of Home Phone Number", "Last 4 digits of Mobile Number", "Expiration Date",
        "Access Code", "Security Code", "Date of Birth", "PIN Code"];

    const handleNetworkCheckboxGroupChange = (event) => {
        let SelectedNetworkValue;
        SelectedNetworkValue = event;
        let updatedSelectedNetworks = [
            ...(methods.getValues("additional_card_profile_registration") ?? []),
        ];
        if (updatedSelectedNetworks.includes(SelectedNetworkValue)) {
            updatedSelectedNetworks = updatedSelectedNetworks.filter(
                (card) => card !== SelectedNetworkValue,
            );
        } else {
            updatedSelectedNetworks.push(SelectedNetworkValue);
        }
        methods.setValue("additional_card_profile_registration", updatedSelectedNetworks);
        methods.trigger();
        handleValueChanges();
    };

    const generalErrorMessage = "Field is required";
    const validationSchema = Yup.object({
        additional_card_profile_registration: Yup.array(Yup.string())
            .required(generalErrorMessage)
            .min(1, "At least one app must be selected"),
    });

    // Initialize React Hook Form with Yup resolver
    const methods = useForm({
        resolver: yupResolver(validationSchema),
        mode: "all",
        reValidateMode: "all",
        shouldUseNativeValidation: false,
        criteriaMode: "all",
        defaultValues: {
            additional_card_profile_registration: [],
        },
    });
    const fields = [
        "additional_card_profile_registration",
    ];

    useEffect(() => {
        if (!isFetching && Object.keys(formDataJson ?? {}).length) {
            fields.forEach((field) => {
                methods.setValue(field, formDataJson[5]["5_3"][field] ?? "");
            });
            methods.trigger();
            handleValueChanges();
        }
    }, [isFetching]);
    // Controlls destructuring from the method
    const {
        control,
        formState: { errors },
    } = methods;

    // Trigger validation when component mounts
    React.useEffect(() => {
        methods.trigger();
    }, []);

    const handleValueChanges = () => {
        const values = methods.getValues();
        setAddFormData({
            ...addFormData,
            5: {
                ...addFormData["5"],
                "5_3": { ...values },
            },
        });
    };

    React.useEffect(() => {
        const errorsLength = Object.keys(errors)?.length;
        if (errorsLength === 0) setFormValidStates("5_3", true);
        else setFormValidStates("5_3", false);
    }, [Object.keys(errors)?.length]);

    return (
        <React.Fragment>
            <div className="forms-instance">
                <div i2c-grid="grid gap-md" className="section-space">
                    <div i2c-grid="12">
                        <div className="sub-heading">
                            Card Profile Registration
                        </div>
                    </div>
                    <div i2c-grid="12">
                        <div className="custom-label mb-8">
                            Please specify the information a cardholder must provide for authentication for card profile registration:
                        </div>
                        <div className="single-field-wrapper">
                            <Controller
                                name="additional_card_profile_registration"
                                control={control}
                                render={({ field }) => (
                                    <>
                                        <I2cCheckboxGroup
                                            {...field}
                                            className="centeredCheckbox checkbox-margin" ref={checkboxRef}
                                        >
                                            <div i2c-grid="grid gap-sm">
                                                {cardProfileReg.map((card, index) => (
                                                    <>
                                                        <I2cListItem
                                                            key={index}
                                                            i2c-grid="4@md"
                                                            variant="receipt"
                                                            label={card}
                                                            sublabel=""
                                                            value=""
                                                            type="checkbox"
                                                            checked={methods
                                                                .watch("additional_card_profile_registration")
                                                                .includes(card)}
                                                            onI2cCheckboxClicked={(e) => {
                                                                handleNetworkCheckboxGroupChange(card)
                                                            }}
                                                        >
                                                            <I2cCheckbox
                                                                slot="prefix"
                                                                value={card}
                                                                label=""
                                                                ignoreTab
                                                                filled
                                                                checked={methods
                                                                    .watch("additional_card_profile_registration")
                                                                    .includes(card)}
                                                                className="customCheckbox"
                                                            ></I2cCheckbox>
                                                        </I2cListItem>

                                                    </>
                                                ))}
                                            </div>
                                        </I2cCheckboxGroup>
                                        <ErrorMessage
                                            show={
                                                errors.additional_card_profile_registration &&
                                                    methods.formState.touchedFields.additional_card_profile_registration
                                                    ? true
                                                    : false
                                            }
                                            message={
                                                errors.additional_card_profile_registration?.message ?? "Invalid input"
                                            }
                                        />
                                    </>
                                )}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default CardProfileRegistration;
